export default "<div class=\"sign-out\">\n  <div class=\"sign-out-message\">Goodbye</div>\n</div>\n"